export enum AutoCompleteType {
    City = 0,
    Province = 1,
    Supplier = 2,
    Distributor = 3
}



// WEBPACK FOOTER //
// ./src/app/helpers/base-classes/autoCompleteType.ts